import styled from "styled-components"

import Container from "../Container"

export const StyledContainer = styled(Container)`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 16px;
  margin-bottom: 50px;

  @media (max-width: 1335px) {
    grid-template-columns: 1fr 1fr 1fr;
  }

  @media (max-width: 993px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 660px) {
    grid-template-columns: 1fr;
  }
`
